export const translations = {
  en: {
    title: "Patient Questionnaire",
    personalInfo: "Personal Information",
    patientId: "Patient Identification Number",
    Important: "Important",
    "Please Keep This Number Safe": "Please keep this number safe",
    phoneNumber: "Phone Number",
    enterPhoneNumber: "Enter your phone number",
    age: "Age",
    enterAge: "Enter your age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    ethnicity: "Ethnicity",
    indian: "Indian",
    other: "Other",
    pleaseSpecify: "Please specify",
    educationLevel: "Highest level of education completed",
    selectEducation: "-- Select Education Level --",
    primarySchool: "Primary school (5-12 years)",
    middleSchool: "Middle school (12-14 years)",
    secondarySchool: "Secondary school (14-16 years)",
    seniorSecondary: "Senior secondary school (16-18)",
    undergraduate: "Undergraduate",
    postgraduate: "Postgraduate",
    occupation: "Current or previous occupation",
    enterOccupation: "Enter your occupation",
    smartphoneOwner: "Do you own a smartphone?",
    yes: "Yes",
    no: "No",
    healthAwareness: "Health Awareness",
    betelNutCancer: "Can chewing betel nut / areca nut / supari cause cancer?",
    familyHistory: "Family history of oral cavity cancer?",
    lifestyleHabits: "Lifestyle Habits",
    smokingStatus: "Smoking Status",
    smoker: "Smoker",
    exSmoker: "Ex-smoker",
    neverSmoked: "Never smoked",
    ifSmoker: "If smoker or ex-smoker:",
    yearsSmoking: "Years of smoking",
    packsPerDay: "Packs per day",
    yearsSinceStopping: "If ex-smoker, years since stopping",
    alcoholConsumption: "Alcohol Consumption",
    alcoholPlaceholder: "Estimate units per week",
    oralHabits: "Oral Habits",
    tobaccoChewing: "Tobacco chewing",
    betelNutChewing: "Betel nut (supari) chewing",
    gutkhaChewing: "Gutkha chewing",
    betelQuidChewing: "Betel quid chewing",
    mishriUse: "Mishri use",
    daily: "Daily",
    weekly: "Weekly",
    exUser: "Ex-user",
    never: "Never",
    timesPerDay: "Times per day",
    durationYears: "Duration (years)",
    symptoms: "Symptoms",
    lumps: "Do you have any lumps, lesions or ulcers in the mouth or throat which are not healing?",
    soreness: "Do you have any soreness or pain in your mouth or throat?",
    painSwallowing: "Do you have any pain when you swallow?",
    difficultySwallowing: "Do you have any difficulty swallowing?",
    difficultyMovingTongue: "Do you have any difficulty moving your tongue?",
    difficultyOpeningJaw: "Do you have any difficulty opening or moving your jaw?",
    whitePatches: "Do you have any white patches inside your mouth?",
    durationOfSymptoms: "Duration of symptoms",
    selectDuration: "-- Select Duration --",
    lessThan2Weeks: "Less than 2 weeks",
    twoWeeksTo3Months: "2 weeks – 3 months",
    threeTo6Months: "3 – 6 months",
    sixTo12Months: "6 - 12 months",
    oneTo3Years: "1 – 3 years",
    moreThan3Years: "More than 3 years",
    documentation: "Documentation",
    photographs: "Photographs",
    requiredPhotos: "Required photos",
    requiredPhotosHelp: "All four photos are required to submit the form.",
    optionalPhotos: "Optional photos",
    optionalPhotosHelp: "Add these photos when available.",
    required: "Required",
    optional: "Optional",
    clinicalObservation: "Clinical Observation",
    requiredObservations: "Required observations",
    optionalObservations: "Optional observations",
    upperLip: "Upper Lip",
    lowerLip: "Lower Lip",
    leftCheek: "Left Cheeks (Inside)",
    rightCheek: "Right Cheeks (Inside)",
    tongueTop: "Tongue Top",
    tongueBack: "Tongue Back",
    leftSideTongue: "Left Side Tongue",
    rightSideTongue: "Right Side Tongue",
    roofOfMouth: "Roof of Mouth",
    bottomOfMouth: "Bottom of Mouth",
    gums: "Gums",
    backOfThroat: "Back of Throat",
    addPhoto: "Add Photo",
    changePhoto: "Change Photo",
    note: "Note",
    submit: "Submit",
    submitting: "Submitting...",
    success: "Success",
    error: "Error",
    formSubmitted: "Form submitted successfully!",
    formFailed: "Form submission failed",
    submissionError: "An error occurred during form submission",
    ok: "OK",
    newPatient: "New Patient",
    existingPatient: "Existing Patient",
    generatingId: "Generating Patient ID...",
    enterPatientId: "Enter Patient ID",
    fetchDetails: "Fetch Details",
    fetchingDetails: "Fetching Details...",
    patientNotFound: "Patient not found",
    back: "Back",
    imageLoadError: "Failed to load image",
    patientImages: "Patient Images",
    oralSite: "Oral Site",
    viewImage: "View Image",
    close: "Close",
    loading: "Loading..."
  },
  hi: {
    title: "रोगी प्रश्नावली",
    personalInfo: "व्यक्तिगत जानकारी",
    patientId: "रोगी पहचान संख्या",
    Important: "महत्वपूर्ण",
    "Please Keep This Number Safe": "कृपया इस नंबर को सुरक्षित रखें",
    phoneNumber: "फ़ोन नंबर",
    enterPhoneNumber: "अपना फ़ोन नंबर दर्ज करें",
    age: "आयु",
    enterAge: "अपनी आयु दर्ज करें",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    ethnicity: "जातीयता",
    indian: "भारतीय",
    other: "अन्य",
    pleaseSpecify: "कृपया निर्दिष्ट करें",
    educationLevel: "पूर्ण की गई शिक्षा का उच्चतम स्तर",
    selectEducation: "-- शिक्षा स्तर चुनें --",
    primarySchool: "प्राथमिक विद्यालय (5-12 वर्ष)",
    middleSchool: "मध्य विद्यालय (12-14 वर्ष)",
    secondarySchool: "माध्यमिक विद्यालय (14-16 वर्ष)",
    seniorSecondary: "वरिष्ठ माध्यमिक विद्यालय (16-18)",
    undergraduate: "स्नातक",
    postgraduate: "स्नातकोत्तर",
    occupation: "वर्तमान या पिछला व्यवसाय",
    enterOccupation: "अपना व्यवसाय दर्ज करें",
    smartphoneOwner: "क्या आपके पास स्मार्टफोन है?",
    yes: "हाँ",
    no: "नहीं",
    healthAwareness: "स्वास्थ्य जागरूकता",
    betelNutCancer: "क्या सुपारी / अरेका नट चबाने से कैंसर हो सकता है?",
    familyHistory: "क्या परिवार में किसी को मुंह के कैंसर का इतिहास है?",
    lifestyleHabits: "जीवनशैली की आदतें",
    smokingStatus: "धूम्रपान की स्थिति",
    smoker: "धूम्रपान करने वाला",
    exSmoker: "पूर्व धूम्रपान करने वाला",
    neverSmoked: "कभी धूम्रपान नहीं किया",
    ifSmoker: "यदि धूम्रपान करने वाला या पूर्व धूम्रपान करने वाला है:",
    yearsSmoking: "धूम्रपान के वर्ष",
    packsPerDay: "प्रति दिन पैक",
    yearsSinceStopping: "यदि पूर्व धूम्रपान करने वाला है, तो छोड़ने के बाद के वर्ष",
    alcoholConsumption: "शराब का सेवन",
    alcoholPlaceholder: "प्रति सप्ताह अनुमानित इकाइयाँ",
    oralHabits: "मौखिक आदतें",
    tobaccoChewing: "तंबाकू चबाना",
    betelNutChewing: "सुपारी चबाना",
    gutkhaChewing: "गुटखा चबाना",
    betelQuidChewing: "पान चबाना",
    mishriUse: "मिश्री का उपयोग",
    daily: "दैनिक",
    weekly: "साप्ताहिक",
    exUser: "पूर्व उपयोगकर्ता",
    never: "कभी नहीं",
    timesPerDay: "प्रति दिन कितनी बार",
    durationYears: "अवधि (वर्ष)",
    symptoms: "लक्षण",
    lumps: "क्या आपके मुंह या गले में कोई गांठ, घाव या अल्सर है जो ठीक नहीं हो रहा है?",
    soreness: "क्या आपके मुंह या गले में कोई दर्द या पीड़ा है?",
    painSwallowing: "क्या आपको निगलते समय कोई दर्द होता है?",
    difficultySwallowing: "क्या आपको निगलने में कोई कठिनाई होती है?",
    difficultyMovingTongue: "क्या आपको अपनी जीभ हिलाने में कोई कठिनाई होती है?",
    difficultyOpeningJaw: "क्या आपको अपना जबड़ा खोलने या हिलाने में कोई कठिनाई होती है?",
    whitePatches: "क्या आपके मुंह के अंदर कोई सफेद धब्बे हैं?",
    durationOfSymptoms: "लक्षणों की अवधि",
    selectDuration: "-- अवधि चुनें --",
    lessThan2Weeks: "2 सप्ताह से कम",
    twoWeeksTo3Months: "2 सप्ताह - 3 महीने",
    threeTo6Months: "3 - 6 महीने",
    sixTo12Months: "6 - 12 महीने",
    oneTo3Years: "1 - 3 साल",
    moreThan3Years: "3 साल से अधिक",
    documentation: "दस्तावेज़ीकरण",
    photographs: "तस्वीरें",
    requiredPhotos: "आवश्यक तस्वीरें",
    requiredPhotosHelp: "फॉर्म जमा करने के लिए सभी चार तस्वीरें आवश्यक हैं।",
    optionalPhotos: "वैकल्पिक तस्वीरें",
    optionalPhotosHelp: "उपलब्ध होने पर ये तस्वीरें जोड़ें।",
    required: "आवश्यक",
    optional: "वैकल्पिक",
    clinicalObservation: "नैदानिक अवलोकन",
    requiredObservations: "आवश्यक अवलोकन",
    optionalObservations: "वैकल्पिक अवलोकन",
    upperLip: "ऊपरी होंठ",
    lowerLip: "निचला होंठ",
    leftCheek: "बायां गाल (अंदर)",
    rightCheek: "दायां गाल (अंदर)",
    tongueTop: "जीभ का ऊपरी हिस्सा",
    tongueBack: "जीभ का पिछला हिस्सा",
    leftSideTongue: "जीभ का बायां हिस्सा",
    rightSideTongue: "जीभ का दायां हिस्सा",
    roofOfMouth: "मुंह की छत",
    bottomOfMouth: "मुंह का तल",
    gums: "मसूड़े",
    backOfThroat: "गले का पिछला हिस्सा",
    addPhoto: "फोटो जोड़ें",
    changePhoto: "फोटो बदलें",
    note: "नोट",
    submit: "जमा करें",
    submitting: "जमा कर रहा है...",
    success: "सफलता",
    error: "त्रुटि",
    formSubmitted: "फॉर्म सफलतापूर्वक जमा किया गया!",
    formFailed: "फॉर्म जमा करना विफल रहा",
    submissionError: "फॉर्म जमा करने के दौरान एक त्रुटि हुई",
    ok: "ठीक है",
    newPatient: "नए रोगी",
    existingPatient: "मौजूदा रोगी",
    generatingId: "रोगी आईडी उत्पन्न कर रहा है...",
    enterPatientId: "रोगी पहचान संख्या दर्ज करें",
    fetchDetails: "विवरण प्राप्त करें",
    fetchingDetails: "विवरण प्राप्त कर रहा है...",
    patientNotFound: "रोगी नहीं मिला",
    back: "वापस",
    imageLoadError: "छवि लोड करने में विफल",
    patientImages: "रोगी की तस्वीरें",
    oralSite: "मौखिक स्थान",
    viewImage: "छवि देखें",
    close: "बंद करें",
    loading: "लोड हो रहा है..."
  },
  mr: {
    title: "रुग्ण प्रश्नावली",
    personalInfo: "वैयक्तिक माहिती",
    patientId: "रुग्ण ओळख क्रमांक",
    Important: "महत्त्वाचे",
    "Please Keep This Number Safe": "कृपया हा क्रमांक सुरक्षित ठेवा",
    phoneNumber: "फोन नंबर",
    enterPhoneNumber: "आपला फोन नंबर प्रविष्ट करा",
    age: "वय",
    enterAge: "आपले वय प्रविष्ट करा",
    gender: "लिंग",
    male: "पुरुष",
    female: "स्त्री",
    ethnicity: "वांशिकता",
    indian: "भारतीय",
    other: "इतर",
    pleaseSpecify: "कृपया निर्दिष्ट करा",
    educationLevel: "पूर्ण केलेले उच्च शिक्षण",
    selectEducation: "-- शिक्षण स्तर निवडा --",
    primarySchool: "प्राथमिक शाळा (5-12 वर्षे)",
    middleSchool: "माध्यमिक शाळा (12-14 वर्षे)",
    secondarySchool: "उच्च माध्यमिक शाळा (14-16 वर्षे)",
    seniorSecondary: "कनिष्ठ महाविद्यालय (16-18)",
    undergraduate: "पदवीधर",
    postgraduate: "पदव्युत्तर",
    occupation: "सध्याचा किंवा मागील व्यवसाय",
    enterOccupation: "आपला व्यवसाय प्रविष्ट करा",
    smartphoneOwner: "आपल्याकडे स्मार्टफोन आहे का?",
    yes: "होय",
    no: "नाही",
    healthAwareness: "आरोग्य जागरूकता",
    betelNutCancer: "सुपारी चघळल्याने कर्करोग होऊ शकतो का?",
    familyHistory: "कुटुंबात तोंडाच्या कर्करोगाचा इतिहास आहे का?",
    lifestyleHabits: "जीवनशैली सवयी",
    smokingStatus: "धूम्रपान स्थिती",
    smoker: "धूम्रपान करणारा",
    exSmoker: "माजी धूम्रपान करणारा",
    neverSmoked: "कधीही धूम्रपान केले नाही",
    ifSmoker: "जर धूम्रपान करणारा किंवा माजी धूम्रपान करणारा असेल तर:",
    yearsSmoking: "धूम्रपानाची वर्षे",
    packsPerDay: "दररोज पॅक",
    yearsSinceStopping: "जर माजी धूम्रपान करणारा असेल, तर थांबवल्यापासूनची वर्षे",
    alcoholConsumption: "मद्यपान",
    alcoholPlaceholder: "दर आठवड्याला अंदाजे युनिट्स",
    oralHabits: "तोंडाच्या सवयी",
    tobaccoChewing: "तंबाखू चघळणे",
    betelNutChewing: "सुपारी चघळणे",
    gutkhaChewing: "गुटखा चघळणे",
    betelQuidChewing: "पान चघळणे",
    mishriUse: "मिश्री वापर",
    daily: "दररोज",
    weekly: "साप्ताहिक",
    exUser: "माजी वापरकर्ता",
    never: "कधीही नाही",
    timesPerDay: "दिवसातून किती वेळा",
    durationYears: "कालावधी (वर्षे)",
    symptoms: "लक्षणे",
    lumps: "आपल्या तोंडात किंवा घशात काही गाठी, जखमा किंवा अल्सर आहेत का जे बरे होत नाहीत?",
    soreness: "आपल्या तोंडात किंवा घशात काही वेदना किंवा दुखणे आहे का?",
    painSwallowing: "गिळताना तुम्हाला काही वेदना होतात का?",
    difficultySwallowing: "तुम्हाला गिळताना काही अडचण येते का?",
    difficultyMovingTongue: "तुम्हाला तुमची जीभ हलवताना काही अडचण येते का?",
    difficultyOpeningJaw: "तुम्हाला तुमचा जबडा उघडताना किंवा हलवताना काही अडचण येते का?",
    whitePatches: "तुमच्या तोंडाच्या आत काही पांढरे डाग आहेत का?",
    durationOfSymptoms: "लक्षणांचा कालावधी",
    selectDuration: "-- कालावधी निवडा --",
    lessThan2Weeks: "2 आठवड्यांपेक्षा कमी",
    twoWeeksTo3Months: "2 आठवडे - 3 महिने",
    threeTo6Months: "3 - 6 महिने",
    sixTo12Months: "6 - 12 महिने",
    oneTo3Years: "1 - 3 वर्षे",
    moreThan3Years: "3 वर्षांपेक्षा जास्त",
    documentation: "कागदपत्रे",
    photographs: "छायाचित्रे",
    requiredPhotos: "आवश्यक छायाचित्रे",
    requiredPhotosHelp: "फॉर्म सबमिट करण्यासाठी सर्व चार छायाचित्रे आवश्यक आहेत.",
    optionalPhotos: "पर्यायी छायाचित्रे",
    optionalPhotosHelp: "उपलब्ध असल्यास ही छायाचित्रे जोडा.",
    required: "आवश्यक",
    optional: "पर्यायी",
    clinicalObservation: "क्लिनिकल निरीक्षण",
    requiredObservations: "आवश्यक निरीक्षणे",
    optionalObservations: "पर्यायी निरीक्षणे",
    upperLip: "वरचा ओठ",
    lowerLip: "खालचा ओठ",
    leftCheek: "डावा गाल (आत)",
    rightCheek: "उजवा गाल (आत)",
    tongueTop: "जीभेचा वरचा भाग",
    tongueBack: "जीभेचा मागील भाग",
    leftSideTongue: "जीभेची डावी बाजू",
    rightSideTongue: "जीभेची उजवी बाजू",
    roofOfMouth: "टाळू",
    bottomOfMouth: "तोंडाचा तळ",
    gums: "हिरड्या",
    backOfThroat: "घशाचा मागील भाग",
    addPhoto: "फोटो जोडा",
    changePhoto: "फोटो बदला",
    note: "टीप",
    submit: "सबमिट करा",
    submitting: "सबमिट करत आहे...",
    success: "यशस्वी",
    error: "त्रुटी",
    formSubmitted: "फॉर्म यशस्वीरित्या सबमिट केला!",
    formFailed: "फॉर्म सबमिशन अयशस्वी",
    submissionError: "फॉर्म सबमिशन दरम्यान एक त्रुटी आली",
    ok: "ठीक आहे",
    newPatient: "नवीन रुग्ण",
    existingPatient: "विद्यमान रुग्ण",
    generatingId: "रुग्ण आयडी तयार करत आहे...",
    enterPatientId: "रुग्ण आयडी प्रविष्ट करा",
    fetchDetails: "तपशील मिळवा",
    fetchingDetails: "तपशील मिळवत आहे...",
    patientNotFound: "रुग्ण सापडला नाही",
    back: "मागे",
    imageLoadError: "प्रतिमा लोड करण्यात अयशस्वी",
    patientImages: "रुग्णाच्या प्रतिमा",
    oralSite: "तोंडाचे स्थान",
    viewImage: "प्रतिमा पहा",
    close: "बंद करा",
    loading: "लोड करत आहे..."
  }
};
